export const enum EQueryStatus {
    InProgress = 'In Progress',
    Open = 'Open',
    ReOpened = 'Re-opened',
    Responded = 'Response Received',
    Closed = 'Closed'
}

export const unresolvedEQueryStatuses = Object.freeze([
    EQueryStatus.Open,
    EQueryStatus.ReOpened,
    EQueryStatus.InProgress,
]);
